import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
import { withNavbar } from '../../../app/layout/HOC';
import { KoUpReCycle } from '../../../app/models/dataErasure';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

interface RecycleProps{
    koUpReCycle: KoUpReCycle;
}

export const options = {
    plugins: {
        title: {
            display: true,
            text: 'Recycled / Upcycle',
        },
    },
    responsive: true,
    interaction: {
        mode: 'index' as const,
        intersect: false,
    },
    scales: {
        x: {
            stacked: true,
        },
        y: {
            stacked: true,
        },
    },
};

const labels = ['Desktop', 'Laptop', 'Tft', 'MobileTlf'];

function KoUpReCycleChart({koUpReCycle}: RecycleProps) {
    const getData = () => {
        const data = {
            labels,
            datasets: [
                {
                    label: 'Recycled',
                    data: [koUpReCycle?.defectiveDesktop, koUpReCycle?.defectiveLaptop, koUpReCycle?.defectiveTft, koUpReCycle?.defectiveMobileTlf],
                    backgroundColor: 'rgb(68,114,196)',
                    stack: 'Stack 0',
                },
                {
                    label: 'UpCycled',
                    data: [koUpReCycle?.erasedDesktop, koUpReCycle?.erasedLaptop, koUpReCycle?.erasedTft, koUpReCycle?.erasedMobileTlf],
                    backgroundColor: 'rgb(237,125,49)',
                    stack: 'Stack 0',
                },
            ],
        };
        return data;
    }
    return (
        // <Box sx={{ flexGrow: 1 }}>
                // <Box sx={{ mt: 20, width: 400, minHeight: 800 }}>
                <Bar options={options} data={getData()} height={600} width={400}/>
                
                // </Box>
        // </Box>
    )
}


export default KoUpReCycleChart;
